import { render, staticRenderFns } from "./AttachedFile.vue?vue&type=template&id=43fbe9ed&scoped=true&"
import script from "./AttachedFile.vue?vue&type=script&lang=js&"
export * from "./AttachedFile.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFile.vue?vue&type=style&index=0&id=43fbe9ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fbe9ed",
  null
  
)

export default component.exports